<template>
  <header class="main-header-page-hero">
    <div class="main-header-page-hero__icon">
      <feather-icon
        :icon="heroIcon"
        size="28"
      />
    </div>
    <div class="main-header-page-hero__text">
      <h2>{{ heroTitle }}</h2>
      <p>{{ heroSubtitle }}</p>
    </div>

    <div
      v-if="backButton"
      class="main-header-page-hero__actions"
    >
      <button
        type="button"
        class="main-header-page__back"
        @click="router.back()"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          size="16"
        />
        Back
      </button>
    </div>
  </header>
</template>

<script>
import { useRouter } from '@core/utils/utils'
import mainData from './main-data-header'

export default {
  props: {
    backButton: {
      type: Boolean,
      default: false,
    },
    heroIcon: {
      type: String,
      default: 'PieChartIcon',
    },
    heroTitle: {
      type: String,
      default: 'Analysis',
    },
    heroSubtitle: {
      type: String,
      default: 'Choose what you would like to analyse.',
    },
  },
  setup() {
    // the file exports { mainDataHeader: { ... } }, so unwrap it here
    const { mainDataHeader } = mainData
    const { router, route } = useRouter()

    // eslint-disable-next-line no-console
    console.log('mainDataHeader ->>>>>', mainDataHeader)
    // eslint-disable-next-line no-console
    console.log('router ->>>>>', router)
    // eslint-disable-next-line no-console
    console.log('route ->>>>>', route.value.name)

    return {
      mainDataHeader,
      router,
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/pages/main-header-page/main-header-page.scss';
</style>
